import { render, staticRenderFns } from "./PurchaseSubscription.vue?vue&type=template&id=54498b5a&scoped=true"
import script from "./PurchaseSubscription.vue?vue&type=script&lang=js"
export * from "./PurchaseSubscription.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSubscription.vue?vue&type=style&index=0&id=54498b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54498b5a",
  null
  
)

export default component.exports